"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.byId = byId;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _find = _interopRequireDefault(require("lodash/find"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _common = require("./common");
var _settings = require("../../settings");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function byId(state, _ref) {
  var choices = _ref.choices;
  // eslint-disable-line import/prefer-default-export
  var newState = {};
  var _getSettings = (0, _settings.getSettings)(),
    customValidators = _getSettings.customValidators;
  state.allIds.forEach(function (optionId) {
    var option = state[optionId];
    var messages = option.messages;
    var oldMessages = option.messages;

    // filter out error messages for disabled options so they don't trigger error validations
    oldMessages = option.messages.filter(function (message) {
      return message.message.indexOf('Oops!') === -1;
    });
    var isParentChoiceSelected = option.isDependent ? choices[option.parentChoiceId].isSelected : false;
    if (option.presentationName === 'TextEntryRequired' && isParentChoiceSelected) {
      var firstChoice = choices[option.choices[0]];
      messages = firstChoice && !firstChoice.value ? [(0, _common.oops)()] : [];
    } else if (option.isRequired && option.isActive) {
      var selectedChoice = (0, _find["default"])(option.choices, function (choiceId) {
        return choices[choiceId].isSelected;
      });
      messages = !selectedChoice ? [(0, _common.oops)()] : [];
    } else {
      messages = [];
    }
    if (customValidators && customValidators[option.optionType]) {
      var optionChoice = choices[(0, _find["default"])(option.choices, function (choiceId) {
        return choices[choiceId].isSelected;
      })];
      messages = [].concat((0, _toConsumableArray2["default"])(messages), (0, _toConsumableArray2["default"])(customValidators[option.optionType]({
        option: option,
        optionChoice: optionChoice
      })));
    }
    if (!(0, _isEqual["default"])(messages, option.messages)) {
      newState[optionId] = _objectSpread(_objectSpread({}, option), {}, {
        messages: [].concat((0, _toConsumableArray2["default"])(oldMessages), (0, _toConsumableArray2["default"])(messages))
      });
    }
  });
  if (Object.keys(newState).length) {
    return _objectSpread(_objectSpread({}, state), newState);
  }
  return state;
}
//# sourceMappingURL=validateRequiredOptions.js.map